import { w } from '@tinkoff/statist-page-data';
import { cookies } from '../storages/cookies';
import { idCookies } from '../constants/cookieList';
var SHORT_WUID_REGEX = /^[0-9a-f]{16}$/;
var WUID_REGEX = /^[0-9a-f]{32}$/;
var UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
/**
 * Функция гененрирует рандомную hex строку длиной 32 символа
 */
var getRandomHexString = function (length) {
    var result = '';
    if (typeof crypto !== 'undefined') {
        var bytesCount = Math.ceil(length / 2);
        var bytes = new Uint8Array(bytesCount);
        crypto.getRandomValues(bytes);
        bytes.forEach(function (byte) {
            result += byte.toString(16).padStart(2, '0');
        });
    }
    else {
        var hexChars = '0123456789abcdef';
        for (var i = 0; i < length; i++) {
            result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
        }
    }
    return result.substring(0, length);
};
/**
 * Функция валидации wuid. Валидными считаются следующие форматы:
 *   wuid - hex строка из 32 символов, либо из 16 символов;
 *   uuid - hex строка, разделённая дефисами на пять групп в формате 8-4-4-4-12.
 * Поддержка формата uuid нужна для совместимости с webview.
 */
function isValid(wuid) {
    return SHORT_WUID_REGEX.test(wuid) || WUID_REGEX.test(wuid) || UUID_REGEX.test(wuid);
}
/**
 * Функция, возвращающая текуций валидный wuid.
 */
var getCurrent = function (options) {
    var _a, _b;
    var wuid;
    if (options.from === 'cookies') {
        if (options.isWebview) {
            wuid = (_b = (_a = cookies.get(idCookies.webviewWuid.name)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : null;
        }
        else {
            wuid = cookies.get(idCookies.wuid.name);
        }
    }
    else {
        var queryParams = new URLSearchParams(w.location.search);
        wuid = queryParams.get('wuid');
    }
    if (wuid && isValid(wuid)) {
        return wuid;
    }
};
/**
 * Cинхронизирует deprecated куку stDeIdU с обновленным значением wuid,
 * чтобы решить проблему, когда на одной странице присутствуют разные версии логики.
 */
var syncDeprecatedDeviceId = function (wuid) {
    var deprecatedDeviceId = cookies.get(idCookies.deviceId.name);
    if (deprecatedDeviceId !== wuid) {
        cookies.set(idCookies.deviceId, wuid);
    }
};
/**
 * Алгоритм генерации wuid: https://wiki.tcsbank.ru/pages/viewpage.action?pageId=4118367580
 */
export var get = function () {
    var queryParams = new URLSearchParams(w.location.search);
    var isWebview = queryParams.get('iswebview') === 'true';
    var wuidFromQuery = getCurrent({ from: 'query' });
    var wuidFromCookies = getCurrent({ from: 'cookies' });
    var wuidFromMobileBankCookies = getCurrent({ from: 'cookies', isWebview: isWebview });
    var wuid;
    if (isWebview && wuidFromMobileBankCookies) {
        wuid = wuidFromMobileBankCookies;
        cookies.set(idCookies.wuid, wuid);
    }
    else if (wuidFromQuery) {
        wuid = wuidFromQuery;
        if (!wuidFromCookies || isWebview) {
            cookies.set(idCookies.wuid, wuid);
        }
    }
    else {
        wuid = wuidFromCookies;
    }
    if (!wuid) {
        wuid = getRandomHexString(32);
        cookies.set(idCookies.wuid, wuid);
    }
    syncDeprecatedDeviceId(wuid);
    return wuid;
};
//# sourceMappingURL=wuid.js.map